import { render, staticRenderFns } from "./ShowDirect.vue?vue&type=template&id=4ed20b46"
import script from "./ShowDirect.vue?vue&type=script&lang=js"
export * from "./ShowDirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports